import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import WeekCalendar from './WeekCalendar';

const eventStart = moment();

const events = [
  {
    name: 'Event a',
    start: eventStart.clone(),
    end: eventStart.clone().add(45, 'minutes')
  },
  {
    name: 'Event b',
    start: eventStart.clone().add(46, 'minutes'),
    end: eventStart.clone().add(130, 'minutes')
  },
  {
    name: 'Event c',
    start: eventStart.clone().add(1, 'day').add(100, 'minutes'),
    end: eventStart.clone().add(1, 'day').add(180, 'minutes')
  },
  {
    name: 'Event d',
    start: eventStart.clone().add(2, 'day').add(35, 'minutes'),
    end: eventStart.clone().add(2, 'day').add(89, 'minutes')
  },
  {
    name: 'Event e',
    start: eventStart.clone().add(2, 'day').add(90, 'minutes'),
    end: eventStart.clone().add(2, 'day').add(130, 'minutes')
  },
  {
    name: 'Event f',
    start: eventStart.clone().add(3, 'day').add(60, 'minutes'),
    end: eventStart.clone().add(3, 'day').add(120, 'minutes')
  },
  {
    name: 'Event g',
    start: eventStart.clone().add(2, 'day').hours(22).add(35, 'minutes'),
    end: eventStart.clone().add(2, 'day').hours(23).add(89, 'minutes')
  },
];

class WeekCalendarExample extends Component {

  constructor() {
    super();
    this.state = {
      start: moment(),
      end: moment(),
      interval: {
        start: moment(),
        end: moment()
      },
      events,
      getEventInterval: (event) => (
        { start: event.start, end: event.end }
      ),
      eventRenderer: ({ event }) => (
        <div>{event.start.format('HH:mm')} - {event.end.format('HH:mm')}</div>
      ),
      onChange: (event) => {
        console.error('Please create custom implementation of this function');
      },
      zoomLevel: 7,
    };
  }

  onChange = (interval) => {
    this.setState({ interval });
  };

  onPropChange = e => {
    this.setState(e.target.value);
  };

  eventRenderer = ({ event }) =>
    <div className="example-event-renderer">
      <div className="inner">
        <div>
          {event.name}
        </div>
        <div>
          {event.start.format('HH:mm')} - {event.end.format('HH:mm')}
        </div>
      </div>
    </div>;

  render() {
    const { interval } = this.state;
    const properties = { ...WeekCalendar.propTypes };
    const defaultProperties = { ...WeekCalendar.defaultProps };

    return (
      <Example {...this.props}>
        <Properties defaultProps={defaultProperties} onChange={this.onPropChange} propTypes={properties} propValues={this.state}/>
        <div style={{ fontSize: '2rem', fontWeight: '300', marginBottom: 20, textAlign: 'center' }}>
          {interval.start.format('LL')} - {interval.end.format('LL')}
        </div>
        <WeekCalendar {...this.state} onChange={this.onChange} className="week-calendar-example" eventRenderer={this.eventRenderer}/>
        <SourceCode language="javascript" title="The onChange callback">
          {
            '/* For the TimeInput view to be updated the onChange and selected prop must be implemented. Example: */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { start: moment(), end: moment(), events: [] }\n' +
            '}\n' +
            '\n' +
            'onChange(interval) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState(interval)\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<WeekCalendar onChange={this.onChange} className="week-calendar-example" eventRenderer={eventRenderer}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode querySelector=".core-week-calendar"/>
      </Example>
    );
  }

}

WeekCalendarExample.tags = 'date';

export default WeekCalendarExample;
